var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7973 0.211315C19.5268 -0.0588918 19.0885 -0.0588918 18.8181 0.211315L10.0043 9.02128L1.19056 0.211315C0.924911 -0.0636504 0.48649 -0.0712636 0.211406 0.194271C-0.063678 0.459805 -0.0712944 0.898036 0.194355 1.173C0.199895 1.1788 0.205607 1.18442 0.211406 1.19005L9.02518 10L0.211406 18.81C-0.063678 19.0756 -0.0712951 19.5137 0.194441 19.7887C0.460176 20.0637 0.89851 20.0713 1.17359 19.8057C1.17939 19.8001 1.18502 19.7944 1.19056 19.7887L10.0043 10.9787L18.8181 19.7887C19.0932 20.0543 19.5315 20.0467 19.7973 19.7717C20.0565 19.5035 20.0565 19.0782 19.7973 18.81L10.9835 10L19.7973 1.19005C20.0676 0.919752 20.0676 0.481608 19.7973 0.211315Z",
    fill: "#212842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.8182978b.svg";
export { ForwardRef as ReactComponent };